
















import { Component, PropSync, Vue } from "vue-property-decorator";
import SlotTag from "@/types/SlotTag";
import SlotTagService from "@/classes/SlotTagService";

@Component
export default class SlotTagChips extends Vue {
  @PropSync("slotTags", { required: true })
  public readonly tags!: SlotTag[] | string[];

  get normalizedTags(): SlotTag[] {
    if (!this.tags) { return []; }

    // Create a completely new array to avoid any reactive mutations
    return this.tags.map((tag) => {
      // If it's already a SlotTag object, create a new object
      if (typeof tag === "object" && tag !== null && "name" in tag) {
        return { name: tag.name, description: tag.description || "" };
      }
      // If it's a string, convert it to a SlotTag object
      return { name: String(tag), description: "" };
    });
  }

  public getTagColor(tagName: string): string {
    return SlotTagService.getTagColor(tagName);
  }

  public getTagIcon(tagName: string): string {
    return SlotTagService.getTagIcon(tagName);
  }
}
